<template>
  <div class="error-page">
<b-container>
  <b-row class="vh-100 text-center" align-v="center">
    <b-col><h1>No access rights<br>Please contact administrator</h1></b-col>
  </b-row>
</b-container>
  </div>
</template>

<script>
import { basePerimeter } from "@/_perimeters/index";

export default {
  name: 'ErrorPage',
  mounted() {
    if (basePerimeter.isAllowed('view')) {
      this.$router.push("/app/main/dashboard")
    }
  }
};
</script>
